/*
  ✟
  "O SENHOR é o meu pastor, nada me faltará.
  Deitar-me faz em verdes pastos, guia-me mansamente a águas tranqüilas.
  Refrigera a minha alma; guia-me pelas veredas da justiça, por amor do seu nome.
  Ainda que eu andasse pelo vale da sombra da morte, não temeria mal algum, porque tu estás comigo; a tua vara e o teu cajado me consolam.
  Preparas uma mesa perante mim na presença dos meus inimigos, unges a minha cabeça com óleo, o meu cálice transborda.
  Certamente que a bondade e a misericórdia me seguirão todos os dias da minha vida; e habitarei na casa do Senhor por longos dias."
  Salmos 23:1-6
  ✟
*/
const app = {
  title: 'Solaris Works',
  edition: 'Business',
  developer: 'Patrick Palinca Santo André',
  ver: '1.5',
  app_server: 'fiosdeouro.atrisys.com.br',
  app_protocol: 'https',
  dev_mode: true,
  isHttps: false,
  /* isHttps: (document.location.protocol === 'https:'), */
  socket_server: 'wss://atrisys.com.br/wsapp',
  //socket_server: 'ws://192.168.2.102:8081',
  socket_manual: false,
  socketReconnectionDelay: 4000,
  upload_dir: 'https://uploads.atrisys.com.br/fiosdeouro',
  //upload_dir: 'http://localhost/uploads/fiosdeouro',
  key: '74755779accf764a519ccb01cc22947ed3de1169f8fb0be2816315eddf1005688179',
  salt: '747a5779cd4eaca1a7f9475f72ffd54ca3ca891bd5c48a0973484530faf5517c0afef2a579ea38cf5be66e89cc27e267b58fc6ee1b721ea2e6ea6133c70230c2aa66666b7c58bec932f40820b57ae2f97a86c62dfb451bef69bf984763568b660bde64f874bbf47749e2b29493f4e05fe3db611f530296dcac942a25aa1bef14abe344b9cb9d037f44fed9e079c85e2d246225ddc95657737c81793d935964553324118dd2ca86225499315126dbe88b36456271b95a47d76b261a8085d05f95e2f513eb662fc741d55c765abad342dac4e13367dc4707c463edf4c2b31a650792f817a3f343fe06a47c3c29c4c0e69d470e420c1356adf89697328e96b210577',
  theme: 'rainbow',
  generic_license: {
    tid: '00000000000001',
    holder: {
      name: 'Gisele Santo André de Moura',
      cpf: '111.222.333-44'
    },
    company: {
      name: 'Fios de Ouro S/A',
      cnpj: '11.222.333/4444-55'
    },
    domain: 'fiosdeouro',
    since: '2021-01-22 15:07:39',
    until: '3021-01-22 15:07:39'
  }
}

export default app
